import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'

import { AdGroupMasterPage } from '@/components/Ams/AdGroupMasterPage'
import { adGroupMasterSearchSchema, pruned } from '@/components/Ams/search'
import { EMPTY_PRIMARY_FILTERS } from '@/lib/filters'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/marketing/master-files/amazon/')({
  validateSearch: adGroupMasterSearchSchema,
  // A link to this page carries no defaults: the clean URL is the default view.
  search: { middlewares: [stripSearchParams(EMPTY_PRIMARY_FILTERS)] },
  component: AmazonRoute,
})

function AmazonRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <AdGroupMasterPage
      search={search}
      onSearchChange={(next) =>
        void navigate({ search: (current) => pruned({ ...current, ...next }), replace: true })
      }
    />
  )
}
